module.exports = __webpack_public_path__ + "static/fun-time/games/page001_game0/audio//s1_1.mp3";